import { Check, Phone, Award, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ABOUT_IMG = "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=1200&q=80";
const ABOUT_IMG_2 = "https://images.pexels.com/photos/4239130/pexels-photo-4239130.jpeg?w=800";

const FEATURES = [
  {
    Icon: ShieldCheck,
    title: "Insured & Background-Checked Crews",
    desc: "Every technician is W-2, fully insured, and vetted — no random subcontractors on your property.",
  },
  {
    Icon: Award,
    title: "Recurring & One-Time Service",
    desc: "Whether you need nightly office care or a one-shot post-construction clean, the same elevated standard applies.",
  },
];

export const AboutSection = () => (
  <section id="about" className="relative py-24 lg:py-32 bg-[#080808] overflow-hidden">
    {/* Decorative gold accents */}
    <div className="absolute -top-40 -right-40 h-96 w-96 rounded-full bg-[#D4AF37]/5 blur-3xl pointer-events-none" />
    <div className="absolute -bottom-20 left-1/4 h-72 w-72 rounded-full bg-[#D4AF37]/[0.03] blur-3xl pointer-events-none" />

    <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-16 lg:gap-20 items-center relative">
      {/* Image collage */}
      <Reveal direction="right">
        <div className="relative">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border border-white/5">
            <img src={ABOUT_IMG} alt="Premier crew at work" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/40 to-transparent" />
          </div>
          {/* Decorative gold ring */}
          <div className="hidden lg:block absolute -bottom-10 -left-10 w-44 h-44 rounded-full border border-[#D4AF37]/30 pointer-events-none" />
          {/* Floating second image */}
          <div className="hidden md:block absolute -bottom-12 -right-6 lg:-right-12 w-56 h-56 rounded-2xl overflow-hidden border-4 border-[#050505] shadow-2xl">
            <img src={ABOUT_IMG_2} alt="Sparkling result" className="w-full h-full object-cover" />
          </div>
        </div>
      </Reveal>

      {/* Copy */}
      <Reveal direction="left" delay={150}>
        <div>
          <div className="overline text-[#D4AF37] mb-4">About Premier</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-tight">
            We make any space
            <br />
            <span className="gold-grad-text italic">clean, neat & turnkey.</span>
          </h2>
          <p className="mt-6 text-white/65 text-lg leading-relaxed">
            Premier Cleaning Group LLC was built on a simple promise: deliver the same elevated standard on every job — whether it's a 30,000 sq ft corporate floor or a single apartment turnover. We document our work, train our crews relentlessly, and stand behind every visit.
          </p>

          <div className="mt-10 space-y-7">
            {FEATURES.map((f) => (
              <div key={f.title} className="flex gap-5">
                <div className="shrink-0 h-12 w-12 rounded-xl border border-[#D4AF37]/30 bg-[#D4AF37]/10 flex items-center justify-center">
                  <f.Icon size={20} strokeWidth={1.4} className="text-[#D4AF37]" />
                </div>
                <div>
                  <h3 className="text-white font-medium text-lg">{f.title}</h3>
                  <p className="text-white/60 text-sm mt-1 leading-relaxed">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-white/5 flex flex-wrap items-center gap-6">
            <a href="#quote" className="btn-gold">Request Estimate</a>
            <a href="tel:7573542290" className="flex items-center gap-3 group">
              <div className="h-12 w-12 rounded-full border border-[#D4AF37]/40 flex items-center justify-center">
                <Phone size={16} className="text-[#D4AF37]" strokeWidth={1.5} />
              </div>
              <div>
                <div className="overline text-white/50">Have Questions?</div>
                <div className="text-white font-medium group-hover:text-[#D4AF37] transition-colors">757-354-2290</div>
              </div>
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
